var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableActionPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 6.92363C19.1368 7.21895 19.268 7.60262 19.268 8.00043C19.268 8.39825 19.1368 8.78192 18.9 9.07723C17.4 10.8933 13.9856 14.4291 9.99993 14.4291C6.01422 14.4291 2.59993 10.8933 1.09993 9.07723C0.863014 8.78192 0.731873 8.39825 0.731873 8.00043C0.731873 7.60262 0.863014 7.21895 1.09993 6.92363C2.59993 5.10753 6.01422 1.57178 9.99993 1.57178C13.9856 1.57178 17.4 5.10753 18.9 6.92363Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 10.8575C11.5779 10.8575 12.8571 9.57831 12.8571 8.00035C12.8571 6.42239 11.5779 5.14321 9.99997 5.14321C8.42202 5.14321 7.14283 6.42239 7.14283 8.00035C7.14283 9.57831 8.42202 10.8575 9.99997 10.8575Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActionPreview);
export default __webpack_public_path__ + "static/media/table-action-preview.7ebd1c53532ae4b376ca186219e9aa72.svg";
export { ForwardRef as ReactComponent };